import BrandProperties from "../../../../components/Partners/DataIntegrations/BrandProperties/BrandProperties"

const BrandPropertiesScreen = () => {
  return (
    <>
    <BrandProperties/>
    </>
  )
}

export default BrandPropertiesScreen